exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".arrow_box[data-v-7e22bdce]{position:relative;height:100%;width:40px}.arrow_top[data-v-7e22bdce]{-webkit-transform:rotate(-45deg);transform:rotate(-45deg);bottom:50%;right:0;-webkit-transform-origin:bottom;transform-origin:bottom}.arrow_low[data-v-7e22bdce],.arrow_top[data-v-7e22bdce]{width:2px;background-color:#ccc;height:100%;position:absolute}.arrow_low[data-v-7e22bdce]{-webkit-transform:rotate(45deg);transform:rotate(45deg);bottom:-13px;right:48px;-webkit-transform-origin:bottom;transform-origin:bottom}", ""]);

// exports
